import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import { components, elements } from '@peachjar/components';

const { H1, H2 } = elements.headers;
const { WhitespaceColumn, FullSpread } = components;

export default class Error404Screen extends Component {
  render() {
    return (
      <FullSpread>
        <WhitespaceColumn full>
          <H1 h1style>404</H1>
          <H2 h3style>Whoops! Nothing here to see.</H2>
          <Button onClick={() => window.history.back()}>Go back</Button>
        </WhitespaceColumn>
      </FullSpread>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_app/errors/screens/Error404Screen.jsx